module.exports = __webpack_public_path__ + "static/img/image_map _eng.c7acaa96.png";